var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.$c('loading-bar')}},[(_vm.loading || _vm.leaving)?_c('veui-progress',{class:_vm.$c('loading-bar'),attrs:{"value":_vm.value,"ui":_vm.uiParts.progress}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }